import isEmpty from 'lodash/isEmpty';

export type MultipleVersionPickerFieldOption = {
	name: string;
	id: string;
	status: string;
	__typename?: string;
}[];

const constructValuesArray = ({
	defaultValue,
	allowedValues,
}: {
	defaultValue: (string | number)[];
	allowedValues: MultipleVersionPickerFieldOption;
}) => {
	const values: MultipleVersionPickerFieldOption = [];
	for (const defaultValues of defaultValue) {
		for (const isValue of allowedValues) {
			if (isValue.id === defaultValues.toString()) {
				values.push({
					name: isValue.name,
					id: isValue.id,
					status: isValue.status,
				});
			}
		}
	}
	return values;
};

export const getMultipleVersionPickerFieldValue = ({
	defaultValue,
	allowedValues,
}: {
	defaultValue: unknown;
	allowedValues: unknown;
}): MultipleVersionPickerFieldOption | null => {
	let values: MultipleVersionPickerFieldOption = [];
	if (Array.isArray(allowedValues)) {
		if (Array.isArray(defaultValue)) {
			values = constructValuesArray({ defaultValue, allowedValues });
		}
		if (typeof defaultValue === 'string' || typeof defaultValue === 'number') {
			values = constructValuesArray({ defaultValue: [defaultValue], allowedValues });
		}

		return isEmpty(values) ? null : values;
	}
	return null;
};
